export const columns = [
  {
    columnId: 1,
    name: "创建时间",
    key: "createTime",
    minWidth: 80,
  },
  {
    columnId: 2,
    name: "订单操作",
    key: "handle",
    minWidth: "120",
  },
  // {
  //   columnId: 3,
  //   name: "订单状态",
  //   key: "orderStatus",
  //   minWidth: 80,
  // },
  {
    columnId: 4,
    name: "组合订单",
    key: "orderGroup",
    minWidth: 140,
  },
  {
    columnId: 5,
    name: "购买账号",
    key: "buyAccountId",
    minWidth: 170,
  },
  {
    columnId: 6,
    name: "购买订单号",
    key: "buyOrderNumber",
    minWidth: 170,
  },
  {
    columnId: 7,
    name: "用户信息",
    key: "userInfo",
    minWidth: 120,
  },
  {
    columnId: 8,
    name: "中英文描述",
    key: "productDesc",
    minWidth: 140,
  },
  {
    columnId: 9,
    name: "国内物流",
    key: "trackingNumberCn",
    minWidth: 150,
  },
  {
    columnId: 10,
    name: "采购/检品工作签",
    key: "staffRemark",
    minWidth: 160,
  },
  {
    columnId: 11,
    name: "商品数量",
    key: "goodsCount",
    minWidth: 80,
  },
  {
    columnId: 12,
    name: "商品总金额",
    key: "sumPrice",
    minWidth: 90,
  },
  // {
  //   columnId: 11,
  //   name: "中国运费",
  //   key: "chineseFreightFee",
  //   minWidth: 110,
  // },
  // {
  //   columnId: 12,
  //   name: "代购手续费",
  //   key: "agentServiceFee",
  //   minWidth: 110,
  // },
  // {
  //   columnId: 13,
  //   name: "用户备注",
  //   key: "customerRemark",
  //   minWidth: 150,
  // },
];